import Procedure from "../../../assets/TasksImages/Procedure.png";
import Documentation from "../../../assets/TasksImages/Documentation.png";
import Coordination from "../../../assets/TasksImages/Coordination.png";
import Compliance from "../../../assets/TasksImages/Compliance.png";
import Info from "../../../assets/TasksImages/Info.png";
import TFSReview from "../../../assets/TasksImages/TFSReview.png";
import Safety from "../../../assets/TasksImages/Safety.png";
import InServiceCheck from "../../../assets/TasksImages/InServiceCheck.png";
import Oversight from "../../../assets/TasksImages/Oversight.png";
import React from "react";

const sectionStyle = {
    width: '20px',
    height: '20px',
};

const  TaskSymbols = [
    {
        fileId: 1,
        desc: 'Compliance',
        image: <img src={Compliance} style={sectionStyle}/>
    },
    {
        fileId: 2,
        desc: 'Coordination',
        image: <img src={Coordination} style={sectionStyle}/>
    },
    {
        fileId: 3,
        desc: 'Documentation',
        image: <img src={Documentation} style={sectionStyle}/>
    },
    {
        fileId: 4,
        desc: 'Info',
        image: <img src={Info} style={sectionStyle}/>
    },
    {
        fileId: 5,
        desc: 'In-Service',
        image: <img src={InServiceCheck} style={sectionStyle}/>
    },
    {
        fileId: 6,
        desc: 'Procedure',
        image: <img src={Procedure} style={sectionStyle}/>
    },
    {
        fileId: 7,
        desc: 'Safety',
        image: <img src={Safety} style={sectionStyle}/>
    },
    {
        fileId: 8,
        desc: 'Oversight',
        image: <img src={Oversight} style={sectionStyle}/>
    },
    {
        fileId: 9,
        desc: 'Review',
        image: <img src={TFSReview} style={sectionStyle}/>
    }
    ];

export default TaskSymbols;